import { Typography } from "e100-react-components";
import React from "react";

interface CarLicenseProps {
  autoNumber?: Nullable<string>;
}

export const CarLicense = ({ autoNumber = '' }: CarLicenseProps) => {
  return (
    <Typography variant="subtitle2" color="textPrimary">
      {autoNumber} • E-BOX
    </Typography>
  );
};
